<template>
  <ul class="app-menu list-unstyled accordion" id="menu-accordion">
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="activeRoute == 'overview' ? 'active' : ''"
        :to="{ name: 'overview' }"
      >
        <span class="nav-icon">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-house-door"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M7.646 1.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5v-4H7v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6zM2.5 7.707V14H6v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4h3.5V7.707L8 2.207l-5.5 5.5z"
            />
            <path
              fill-rule="evenodd"
              d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
            />
          </svg>
        </span>
        <span class="nav-link-text">Overview</span>
      </router-link>
    </li>
    <!-- Department start -->
    <li class="nav-item" v-if="type == 'staffRole' || type == 'admin'">
      <router-link
        class="nav-link"
        :class="activeRoute == 'approvePgcoord' ? 'active' : ''"
        :to="{ name: 'approvePgcoord' }"
      >
        <span class="nav-icon">
          <b-icon icon="app-indicator" aria-hidden="true"></b-icon>
        </span>
        <span class="nav-link-text">My Department</span>
      </router-link>
    </li>
    <!-- Department end -->


    <!-- Academics start -->
    <li class="nav-item has-submenu" v-if="type == 'admin' || type == 'pgSchool'">
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-academics"
        aria-expanded="false"
        aria-controls="submenu-academics"
      >
        <span class="nav-icon">
          <b-icon icon="building" aria-hidden="true"></b-icon>
        </span>
        <span class="nav-link-text">Academics</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-academics"
        class="collapse submenu submenu-academics"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item" v-if="type == 'admin' || type == 'pgSchool'">
            <router-link class="submenu-link" :to="{ name: 'collegeManagement' }"
              >Colleges</router-link
            >
          </li>
          <li class="submenu-item" v-if="type == 'admin' || type == 'pgSchool'">
            <router-link class="submenu-link" :to="{ name: 'departmentManagement' }"
              >Departments</router-link
            >
          </li>
          <li class="submenu-item" v-if="type == 'admin' || type == 'pgSchool'">
            <router-link class="submenu-link" :to="{ name: 'programmeManagement' }"
              >Programmes</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'courses' }"
              >Courses</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'curriculum' }"
              >Curriculum</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'courseRegistration' }"
              >Course Registration</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'resultManagement' }"
              >Results</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'courseOutstanding' }"
              >Course Outstanding</router-link
            >
          </li>
        </ul>
      </div>
    </li>
    <!-- Academics end -->

    <!-- Adminssion start-->
    <li
      class="nav-item has-submenu"
      v-if="
        type == 'staffRole' ||
          type == 'admin' ||
          type == 'pgSchool' ||
          type == 'pgCoord'
      "
    >
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-admin"
        aria-expanded="false"
        aria-controls="submenu-admin"
      >
        <span class="nav-icon">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-files"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
            />
            <path
              d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z"
            />
          </svg>
        </span>
        <span class="nav-link-text">Admission</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-admin"
        class="collapse submenu submenu-1"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'applicants' }"
              >Applicants</router-link
            >
          </li>
          <!-- <li class="submenu-item">
            <router-link class="submenu-link" to="/account">
              Account</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" to="/settings"
              >Settings</router-link
            >
          </li> -->
        </ul>
      </div>
    </li>

    <!-- Adminssion end-->

    <!-- payment start-->
    <li
      class="nav-item has-submenu"
      v-if="type == 'accountants' || type == 'admin'"
    >
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-1"
        aria-expanded="false"
        aria-controls="submenu-1"
      >
        <span class="nav-icon">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-files"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
            />
            <path
              d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z"
            />
          </svg>
        </span>
        <span class="nav-link-text">Payment</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-1"
        class="collapse submenu submenu-1"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'Admission' }"
              >Admission</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'Student' }">
              Student</router-link
            >
          </li>
        </ul>
      </div>
    </li>
    <!-- payment end-->

    <!-- bursary start-->
    <li
      class="nav-item has-submenu"
      v-if="isBursaryVisible"
    >
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-bursary"
        aria-expanded="false"
        aria-controls="submenu-bursary"
      >
        <span class="nav-icon">
          <b-icon icon="cash-stack" aria-hidden="true"></b-icon>
        </span>
        <span class="nav-link-text">Bursary</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-bursary"
        class="collapse submenu submenu-bursary"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'bursaryDashboard' }"
              >Dashboard</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'billingManagement' }"
              >Billing / Fees</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'feeScheduleManagement' }"
              >Fee Schedule</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'admissionFees' }"
              >Admission Fees</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'serviceTypes' }"
              >Service Types</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'specialPayments' }"
              >Special Payments</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'studentLedger' }"
              >Student Ledger</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'gatewayReports' }"
              >Gateway Reports</router-link
            >
          </li>
        </ul>
      </div>
    </li>
    <!-- bursary end-->

    <!-- student start-->
    <li
      class="nav-item has-submenu"
      v-if="type == 'admin' || type == 'pgSchool'"
    >
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-studend"
        aria-expanded="false"
        aria-controls="submenu-studend"
      >
        <span class="nav-icon">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-files"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
            />
            <path
              d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z"
            />
          </svg>
        </span>
        <span class="nav-link-text">Student</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-studend"
        class="collapse submenu submenu-studend"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'studprofile' }"
              >Profile</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'feeScheduleManagement' }"
              >Fee Schedule</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'studentLedger' }"
              >Student Ledger</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'staffManagement' }"
              >PG Staff</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'studentDataDownload' }"
              >Download Student Data</router-link
            >
          </li>
        </ul>
      </div>
    </li>
    <!-- student end-->

    <!-- settings start-->
    <li class="nav-item has-submenu" v-if="type == 'admin'">
      <a
        class="nav-link submenu-toggle"
        href="#"
        data-toggle="collapse"
        data-target="#submenu-settings"
        aria-expanded="false"
        aria-controls="submenu-settings"
      >
        <span class="nav-icon">
          <b-icon icon="gear" aria-hidden="true"></b-icon>
        </span>
        <span class="nav-link-text">Settings</span>
        <span class="submenu-arrow">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-down"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </a>
      <div
        id="submenu-settings"
        class="collapse submenu submenu-settings"
        data-parent="#menu-accordion"
      >
        <ul class="submenu-list list-unstyled">
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'sessionSettings' }"
              >Sessions</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'myProfile' }"
              >My Profile</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'accessControl' }"
              >Access Control</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'auditLog' }"
              >Audit Log</router-link
            >
          </li>
          <li class="submenu-item">
            <router-link class="submenu-link" :to="{ name: 'helpdesk' }"
              >Helpdesk</router-link
            >
          </li>
        </ul>
      </div>
    </li>
    <!-- settings end-->
  </ul>
</template>

<script>
export default {
  data() {
    return {
      staffRoles: ["HOD", "ADMISSIONOFFICER"],
      accountants: ["BURSARY"],
      pgSchool: ["COLLEGEOFFICER", "PGSCHOOL"],
      admin: ["SUPERADMIN", "ICT", "ADMIN"],
      pgCoord: ["PG-COORD"],
      type: "",
    };
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to);
    console.log(from);
    //  console.log(next)
  },
  computed: {
    activeRoute() {
      console.log(this.$router.history.current.name);

      return this.$router.history.current.name;
    },
    isBursaryVisible() {
      let roles = this.$store.state.user.roles || [];
      return roles.some((r) => ["SUPERADMIN", "BURSARY", "ICT", "ADMIN", "PGSCHOOL"].includes(r));
    },
  },
  methods: {
    changeActive() {},
    readySideBar() {
      let roles = this.$store.state.user.roles;
      console.log(roles, "seeee");
      let staffRole = roles.some((item) => this.staffRoles.includes(item));
      let admin = roles.some((item) => this.admin.includes(item));
      let accountants = roles.some((item) => this.accountants.includes(item));
      let pgSchool = roles.some((item) => this.pgSchool.includes(item));
      let pgCoord = roles.some((item) => this.pgCoord.includes(item));
      if (admin) {
        this.type = "admin";
      } else if (staffRole) {
        this.type = "staffRole";
      } else if (accountants) {
        this.type = "accountants";
      } else if (pgSchool) {
        this.type = "pgSchool";
      } else if (pgCoord) {
        this.type = "pgCoord";
      } else {
        this.type = "no role defined";
      }

      this.$store.dispatch("roleUsed", this.type);
    },
  },
  created() {
    this.readySideBar();
  },
};
</script>
